// extracted by mini-css-extract-plugin
export default {"cwdLink":"CwdStyle__cwdLink___2N45F"};